<template>
    <div class="text-center login-container">
        <form 
            class="login-form" 
            @submit.prevent="login"
        >
            <img 
                src="/img/logos/orange_black.png" 
                alt="SwiftWork" 
                class="login-logo"
            >
            <br>
            <h3 v-if="sysSetting('company_name')">
                {{ sysSetting('company_name') }}
            </h3>
            <br>
            <div 
                class="alert" 
                :class="'alert-' + message.type" 
                role="alert" 
                v-if="message.text"
            >
                {{ message.text }}
            </div>
            <label 
                for="inputEmail" 
                class="sr-only"
            >Email address</label>
            <input 
                type="email" 
                id="inputEmail" 
                class="form-control" 
                placeholder="Email address" 
                required 
                autofocus 
                v-model="email"
            >
            <label 
                for="inputPassword" 
                class="sr-only"
            >Password</label>
            <input 
                type="password" 
                id="inputPassword" 
                class="form-control" 
                placeholder="Password" 
                required 
                v-model="password"
            >
            <br>
            <button 
                class="btn btn-lg btn-primary btn-block" 
                type="submit"
            >
                Log in
            </button>
        </form>
    </div>
</template>

<script>
import AuthService from "../services/AuthService.js";
import SettingsMixin from '../mixins/SystemSettings';

export default {
    mixins: [
        SettingsMixin,
    ],
    data: function() {
        return {
            authService: AuthService,
            email: "",
            password: "",
            message: {
                type: "info",
                text: false
            }
        };
    },
    methods: {
        login: function() {
            this.message.text = "Logging in...";
            this.message.type = "info";
            setTimeout(() => {
                this.authService
                    .login(this.email, this.password)
                    .then(() => {
                        this.message.text = "Login successful";
                        this.message.type = "success";
                        setTimeout(() => {
                            if (this.$route.query.redirect) {
                                window.location.replace(`/#/${this.$route.query.redirect}`);
                            }
                            this.$router.push({ path: "/" });
                        }, 500);
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status === 401) {
                                this.message.text = "Login incorrect, try again";
                                this.message.type = "danger";
                            } else if (error.response.status === 429) {
                                const data = error.response.data;
                                if (data && data.message) {
                                    this.message.text = data.message;
                                } else {
                                    this.message.text = "Too many login attempts. Please try again later.";
                                }
                                this.message.type = "danger";
                            } else {
                                this.message.text = "Server error: "+error.response.status;
                                this.message.type = "danger";
                            }
                        } else if (error.request) {
                            this.message.text = "No response from server";
                            this.message.type = "danger";
                        }
                    });
            }, 250);
        },

        logout: function() {
            this.authService.logout();
        }
    }
};
</script>
<style>
.login-container {
  width: 100%;
    min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-form {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/LoginComponent.vue